module.exports = __webpack_public_path__ + "img/mergdata_hifi_3.b779b0b3.png";